import React from 'react';

export type SortIconDirection = 'asc' | 'desc' | 'none';

interface SortArrowIconProps {
    direction: SortIconDirection;
    size?: number;
}

const SortArrowIcon = ({ direction, size = 14 }: SortArrowIconProps) => {
    const commonProps = {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round" as const,
        strokeLinejoin: "round" as const
    };

    if (direction === 'asc') {
        return (
            <svg {...commonProps}>
                <path d="m5 12 7-7 7 7" />
                <path d="M12 19V5" />
            </svg>
        );
    }

    if (direction === 'desc') {
        return (
            <svg {...commonProps}>
                <path d="M12 5v14" />
                <path d="m19 12-7 7-7-7" />
            </svg>
        );
    }

    return (
        <svg {...commonProps}>
            <path d="m21 16-4 4-4-4" />
            <path d="M17 20V4" />
            <path d="m3 8 4-4 4 4" />
            <path d="M7 4v16" />
        </svg>
    );
};

export default SortArrowIcon;

